/* DOG1 LP — Smooth-Scroll für CTA-Anker (#buybox).
 *
 * - data-lp-anchor: aktiviert das Verhalten je Link.
 * - prefers-reduced-motion: instant scroll, kein Animations-Path.
 * - Fokus-Move auf Ziel-Container nach Scroll (Screen-Reader-Kontext).
 * - Ohne JS funktioniert der native <a href="#buybox">-Sprung.
 */
(function () {
  'use strict';

  var anchors = document.querySelectorAll('[data-lp-anchor]');
  if (!anchors.length) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  anchors.forEach(function (el) {
    el.addEventListener('click', function (e) {
      var href = this.getAttribute('href');
      if (!href || href.charAt(0) !== '#') return;
      var target = document.querySelector(href);
      if (!target) return;

      e.preventDefault();

      if (reduceMotion) {
        target.scrollIntoView({ block: 'start' });
      } else {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      // History anpassen, damit Browser-Back funktioniert.
      if (window.history && typeof window.history.replaceState === 'function') {
        window.history.replaceState(null, '', href);
      }

      // Fokus auf den Ziel-Container schieben, damit Screen-Reader-User
      // den Kontext-Wechsel mitbekommen. tabindex=-1 erlaubt programmatischen
      // Fokus, ohne den Tab-Order zu verändern.
      if (!target.hasAttribute('tabindex')) {
        target.setAttribute('tabindex', '-1');
      }
      target.focus({ preventScroll: true });
    });
  });
})();
